import { supabase } from '../supabase';

interface SendEmailParams {
  exporter_id: number;
  subject: string;
  html: string;
  to?: string[];
  link?: string;
  linkText?: string;
}

export async function sendEmail({
  exporter_id,
  subject,
  html,
  to,
  link,
  linkText,
}: SendEmailParams): Promise<boolean> {
  try {
    const { data: sessionData } = await supabase.auth.getSession();
    const accessToken = sessionData?.session?.access_token;
    if (!accessToken) {
      throw new Error('Not authenticated');
    }
    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-email`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          exporter_id,
          subject,
          html,
          to,
          link,
          linkText,
        }),
      }
    );

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Failed to send email');
    }

    return true;
  } catch (error) {
    console.error('Error sending email:', error);
    return false;
  }
}
